// Captures any jQuery already present on `window`, so the host page's plugins
// (e.g. atriumhealth.org's `fullCalendar`) can be re-attached to a jQuery that
// replaces it.
//
// Paired with `_restore_host_jquery.js` which copies the captured
// `fn.*` extensions onto the newly loaded jQuery.
if (typeof window !== "undefined" && window.jQuery) {
  window.__sparkleCapturedHostJQuery = window.jQuery;
}
